import { Box, Grid, Stack, Typography } from "@mui/material";
import appcolors from "../../constants/Colors";
import { useTranslation } from "react-i18next";

function StatusCard({ item }) {
  const { t } = useTranslation("dashboard");

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Stack
        p={2}
        borderRadius={"10px"}
        bgcolor={appcolors.white}
        boxShadow={"2px 2px 10px 0px #ECF0F2"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Box>
          <Typography
            variant={"body1"}
            fontWeight={500}
            textTransform={"capitalize"}
          >
            {t(item?.primary)}
          </Typography>
          <Typography
            variant={"body2"}
            fontSize={"0.75rem"}
            color={appcolors.crayolaGrey}
          >
            {t(item?.secondary)}
          </Typography>
        </Box>
        <Typography variant={"h3"} fontSize={"1.1rem"} fontWeight={800}>
          {item?.value}
        </Typography>
      </Stack>
    </Grid>
  );
}

export default StatusCard;
